var lib_core = require("lib-core");

var InspectorStateMachine = require("./../inspector/inspectorStateMachine.js");

var OptionsStateMachine = function (root, model, events) {
    var self = this;

    InspectorStateMachine.call(this, root, model, events);

    this.addEventAction("idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.OPTIONS_TOGGLE;
        },
        function(cEvent){
            self.model.visible(!self.model.visible());
        }
    );
};

lib_core.inherit(OptionsStateMachine, InspectorStateMachine);

module.exports = OptionsStateMachine;
